<template>
  <div>
    <Nav></Nav>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col>
          <h1>Listas de Insumos</h1>
        </b-col>
      </b-row>
      <b-row class="text-left my-2">
        <b-col>
          <b-button variant="success" @click="$bvModal.show('modal-newProduct')" size="sm mr-3">Crear Lista +</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" @keyup="page = 1" debounce="500"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table small striped hover :items="supply_list" :fields="comprasLabels" responsive>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(status)="data">
              <b-badge :variant="statusBadge(data.item.status).variant">{{ statusBadge(data.item.status).text
                }}</b-badge>
            </template>
            <template #cell(buttons)="data">
              <b-button size="sm" variant="success" @click="$router.push('/supply/list/' + data.item.id)" class="mr-1">
                +Info
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
    <b-modal id="modal-newProduct" @close="emptyNewItem" :hide-footer="true" size="xl" title="Agregar Lista">
      <b-row>
        <b-col lg="12" cols="12">
          <b-form-group label="Nombre" description="Introduce el nombre">
            <b-form-input v-model="newItem.name" placeholder="Nombre" required></b-form-input>
          </b-form-group>
        </b-col>

        <b-col lg="12" cols="12">
          <b-form-group label="Descripcion" description="Introduce la descripcion">
            <b-form-input v-model="newItem.description" placeholder="Nombre" required></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="my-3">
          <b-button class="mr-3" @click="createNewItem" variant="success">Guardar</b-button>
          <b-button class="mr-3" @click="$bvModal.hide('modal-newProduct'); emptyNewItem();"
            variant="danger">Cancelar</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
import Nav from "../components/Nav.vue";
import router from "../router"
import moment from 'moment';

export default {
  name: "SupplyLists",
  components: {
    Nav
  },

  data() {
    return {
      newItem: {
        name: '',
        description: ''
      },
      initialDate: "",
      lastDate: "",
      allSucsArray: [],
      search: "",
      supply_list: [],
      actualSucursal: {
        id: null
      },
      comprasLabels: [
        { key: "id", label: "ID" },
        { key: "name", label: "Nombre" },
        { key: "buttons", label: "" }
      ]
    };
  },

  computed: {

  },
  watch: {},
  mounted() {
    this.getLists()
  },
  created() {

  },
  methods: {
    createNewItem() {
      let that = this
      let elm = this.newItem
      axios.post("/shoppinglist", elm)
        .then(function (res) {
          if (res.data.id > 0) {
            that.getLists()
            that.emptyNewItem()
            that.$bvModal.hide("modal-newProduct")
          }
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })

    },
    emptyNewItem() {
      this.newItem = {
        name: '',
        description: ''
      }
    },
    searchRecv(p) {
      this.initialDate = moment(p.initDate).format('YYYY-MM-DD');
      this.lastDate = moment(p.endDate).format('YYYY-MM-DD');
      this.allSucsArray = p.sucursales
      this.getLists()
    },
    newPOError(evt) {
      console.log("error reading")
      console.log(evt)
      this.getLists()
      this.makeToast("danger", "Error", evt.data)
    },
    statusBadge(status) {
      let rtn = { variant: "", text: status }
      switch (status) {
        case "DRAFT":
          rtn.variant = "warning"
          rtn.text = "Borrador"
          break;
        case "SENT":
          rtn.variant = "success"
          rtn.text = "Enviado"
          break;
        case "CANCELED":
          rtn.variant = "danger"
          rtn.text = "Cancelado"
          break;
      }
      return rtn
    },
    newPOCreated(evt) {
      console.log(evt)
      router.push('/compra/' + evt)
      this.getLists()
    },
    getLists() {
      let that = this
      axios.get("/shoppinglists")
        .then(function (res) {
          that.supply_list = res.data
        }).catch(function (err) {
          console.error(err)
        })
    },
    makeToast(variant = null, title = "", text = "") {
      this.$bvModal.msgBoxOk(text, {
        title: title,
        okVariant: variant,
        centered: true
      })
      // this.$bvToast.toast(text, {
      //   title: title,
      //   variant: variant,
      //   solid: true,
      //   appendToast: true,
      // });
    },
  },
};
</script>
